import { chain } from 'icepick';
import type { Action, StoreActionApi } from '@atlassian/react-sweet-state';
import type { State, ThirdPartyStatus } from '../../../../common/types';

export type SetThirdPartyEntityStatusMappingAction = (
	updatedStatus: ThirdPartyStatus,
) => Action<State, void, void>;

export type SetThirdPartyStatusMappingAction = (
	entityName: string | null,
	updatedStatus: ThirdPartyStatus,
) => Action<State, void, void>;

export const setThirdPartyStatusMapping: SetThirdPartyStatusMappingAction =
	(entityName: string | null, updatedStatus: ThirdPartyStatus) =>
	({ setState, getState }: StoreActionApi<State>) => {
		const state = getState();
		if (state.thirdPartyState.thirdPartyStatusMapping == null || entityName == null) {
			return;
		}

		const newStatus = {
			mappedStatusName: updatedStatus.mappedStatusName,
			statusCategory: updatedStatus.statusCategory,
		};

		const newState = chain(state)
			.setIn(
				[
					'thirdPartyState',
					'thirdPartyStatusMapping',
					'entityStatusMappings',
					entityName,
					'statusMappings',
					updatedStatus.sourceStatusName,
				],
				newStatus,
			)
			.value();

		setState(newState);
	};
